import store from '../../store'
import { SRSDefaults } from './SRSFunctions';

export class Setsubi{
    //Added Line 2026-03-18 jazz, add constants
    static #GROUND_INVESTIGATION_SITE_ID = 2;
    static #GROUND_IMPROVEMENT_WORK_ID = 5;
    static #BASIC_TYPES_ID = 3; 
    static #BASIC_SPECS_ID = 12;

    #Url;
    #axios;
    #UserSetsubiSheetItems;
    #MasterSetsubiSheetItems;
    #RoomList;
    #RoomListPromise; //2026-10-07 jazz, see FetchRoomList
    #isGCPlan; //Added line 2026-03-18 jazz

    constructor (url, axios) {
        this.#axios = axios;
        this.#Url = url;
        this.#UserSetsubiSheetItems = store.state.UserInterface.SetsubiSheet;
        //this.#RoomNames = store.state.PlanInfo.SelectedSetsubi;

        //2026-10-07 jazz, prefetch the room list at SPA boot instead of on Setsubi sheet mount. This
        //object is a singleton (app.js), so by the time the user navigates to the sheet the list is
        //already in hand and Setsubi.vue's await resolves immediately. Not awaited on purpose - the
        //request needs no auth beyond the static SRS-Key header axios is created with.
        this.FetchRoomList(`${process.env.MIX_API_BASEURL}/api/getRooms/names`)
    }

    //********** GETTERS **********
    get UserSetsubiSheetItems(){
        return this.#UserSetsubiSheetItems;
    }

    get RoomList(){
        return this.#RoomList;
    }

    async getMasterItems(){
        // let setsubiItems = await SRSFunc.SRSDefaults.filteredItems((await axios.get(this.#Url)).data)

        const houseTypes = store.state.Master.HouseTypes;
        const selectedHouseType = houseTypes.find(item => item.HouseType == store.state.PlanInfo.HouseType);
        const typeCd = selectedHouseType?.TYPE_CD || null;

        // let setsubiItems = await SRSFunc.SRSDefaults.filteredItems((await axios.get(this.#Url.replace("###", typeCd))).data) 2025-08-13 jazz

        let setsubiItems = await SRSDefaults.filteredItems((await this.#axios.get(this.#Url.replace("###", typeCd))).data)

        return setsubiItems;
    }

    //Added Line 2026-03-18 jazz
    SetGCPlan = async (isGCPlan) =>{
        this.#isGCPlan = isGCPlan; 
    }

    //2026-10-07 jazz, holds the in-flight request so the boot-time prefetch and Setsubi.vue's mount-time
    //call share one response instead of firing twice. Cleared on failure so a later call really retries
    //(otherwise one failed prefetch would wedge the room list empty for the whole session).
    FetchRoomList = async (url) =>{
        if (this.#RoomListPromise) {
            return this.#RoomListPromise;
        }

        this.#RoomListPromise = (async () => {
            try{
                const response = await this.#axios.get(url);

                //2026-10-07 jazz, /api/getRooms/names returns a flat array of names. Treating a
                //non-array as a failure (rather than coercing to []) keeps the retry path below
                //alive - the endpoint returns null if the controller swallows an exception.
                if (!Array.isArray(response.data)) {
                    throw new Error(`unexpected ${url} payload`);
                }

                this.#RoomList = response.data
            } catch(e) {
                this.#RoomListPromise = null;
                console.log(':', e);
            }
        })();

        return this.#RoomListPromise;
    }

    //Save RoomName to store
    // ImportRoomNamesToStore = async () =>{
    //     try{
    //         const response = await axios.get(`${process.env.MIX_API_BASEURL}/api/getRooms`);
    //         //store.dispatch('setRoomNames', response.data)  
    //     } catch(e) {
    //         console.log(':', e);
    //     }
    // }
 
    ImportMasterDataToStore = async () =>{
        try{
            const response  = await this.#axios.get(this.#Url)
            //store.dispatch('SetsubiSheet', response.data)
        }catch(e){
            console.log(e)
        }
    }

    ImportUserDataToStore = async (progressBar = null, setsubiItems = null) =>{
        if(progressBar){
            await progressBar.increment()
        }
  
        if(!setsubiItems){       
            const houseTypes = store.state.Master.HouseTypes;
            const selectedHouseType = houseTypes.find(item => item.HouseType == store.state.PlanInfo.HouseType);
            const typeCd = selectedHouseType?.TYPE_CD || null;

            // setsubiItems = await SRSFunc.SRSDefaults.filteredItems((await axios.get(this.#Url.replace("###", typeCd))).data) 2025-08-13 jazz
            setsubiItems = await SRSDefaults.filteredItems((await this.#axios.get(this.#Url.replace("###", typeCd))).data)
        }

        if(progressBar){
            await progressBar.increment()
        }

        try{
            const jibanIndex       = setsubiItems.findIndex(item => item.id === Setsubi.#BASIC_SPECS_ID);   
            const siteAddressIndex = setsubiItems[jibanIndex].category.findIndex( item => item.id == Setsubi.#GROUND_INVESTIGATION_SITE_ID) 

            //Added Line 2026-03-18 jazz, for GC plan  
            if (this.#isGCPlan){
                const basicTypesIndex =  setsubiItems[jibanIndex].category.findIndex( item => item.id == Setsubi.#BASIC_TYPES_ID);
                const groupdImprovementWorkIndex = setsubiItems[jibanIndex].category.findIndex( item => item.id == Setsubi.#GROUND_IMPROVEMENT_WORK_ID); 

                for(const texture of setsubiItems[jibanIndex].category[basicTypesIndex].textureList){
                    texture.isdisplayed = 1;  
                }

                for(const texture of setsubiItems[jibanIndex].category[groupdImprovementWorkIndex].textureList){
                    texture.isdisplayed = 1;  
                }
             
                for(const texture of setsubiItems[jibanIndex].category[siteAddressIndex].textureList){
                    texture.isdisplayed = 0;  
                }
            }
 
            let tmpTextureArr = [];

            if(store.state.PlanInfo.JibanInfo.jibanList.length > 0 && store.state.PlanInfo.JibanInfo.selectedJibanIdBranch){
                setsubiItems[jibanIndex].category[siteAddressIndex].textureList.forEach( item =>{
                    if(item.texturename === '(*SiteAddress*)'){
                        for(let i = 0; i < store.state.PlanInfo.JibanInfo.jibanList.length; i++){
                            let tmpObj = JSON.parse(JSON.stringify(item))
                            tmpObj.id = 999 + parseInt(store.state.PlanInfo.JibanInfo.jibanList[i].SequentialNo)

                            let jibanDecisionStatus = '';

                            if(store.state.PlanInfo.JibanInfo.jibanList[i].DecisionStatus){
                                jibanDecisionStatus = /^【.*】/.exec(`${store.state.PlanInfo.JibanInfo.jibanList[i].DecisionStatus}`)
                            }

                            tmpObj.texturename = `${store.state.PlanInfo.JibanInfo.jibanList[i].SequentialNo} : ${jibanDecisionStatus} ${store.state.PlanInfo.JibanInfo.jibanList[i].Decision}`
                            tmpTextureArr.push(tmpObj)      
                        }
                    }else{
                        tmpTextureArr.push(item)  
                    }

                    setsubiItems[jibanIndex].category[siteAddressIndex].textureList = tmpTextureArr 
                })
            }

            if(store.state.PlanInfo.JibanInfo.jibanList.length == 0){
               delete setsubiItems[jibanIndex].category[siteAddressIndex].textureList[0]
            }

            // await SRSFunc.SRSDefaults.filteredUserInterface(setsubiItems,'UserSetsubiSheet') 2025-08-13 jazz
            await SRSDefaults.filteredUserInterface(setsubiItems,'UserSetsubiSheet')

            if(progressBar){
                await progressBar.increment()
            }

            if( store.state.PlanInfo.JibanInfo.selectedJibanIdBranch){
                tmpTextureArr.push(setsubiItems[0].category[1].textureList[0] )

                tmpTextureArr.forEach(item =>{
                    if( /\d*/.exec(item.texturename) == store.state.PlanInfo.JibanInfo.selectedJibanIdBranch.SequentialNo ){
                        // store.dispatch('AddToSelectedItems', SRSFunc.SRSDefaults.SelectedDataObj(setsubiItems[0], setsubiItems[0].category[1], null, null, item)) 2025-08-13 jazz
                        store.dispatch('AddToSelectedItems', SRSDefaults.SelectedDataObj(setsubiItems[0], setsubiItems[0].category[1], null, null, item))
                    }
                })
            }
        }finally{
           setsubiItems = null
        } 
    }
}